import { create } from "zustand";
import { getAllGlossaries } from "../services/admin/glossaries";
import { Glossary } from "../types/Glossary";
import { GlossaryState } from "../types/GlossaryState";

export const useGlossaryStore = create<GlossaryState>((set) => ({
  terms: [],
  loading: true,
  fetchGlossary: async () => {
    try {
      const response = await getAllGlossaries();
      const formatted = response.map((term:Glossary) => ({
        term: term.title,
        definition: term.description_html,
				thumbnail: term.thumbnail,
      }));
      set({ terms: formatted, loading: false });
    } catch (error) {
      console.error("Erro ao carregar glossário:", error);
      set({ loading: false });
    }
  },
}));
